import { IPostRegisterHomeModule, PageModule } from "../types/working-model";
import { Get, Post, Put } from "./helpers";

export function GetEvents(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/events/${channel}`, token);
}

export function UpdatePostRegisterPreviewModules(homepage: number, token: string, modules: IPostRegisterHomeModule[]): Promise<any> {
	return Put(`/v3/admin/events/homepage/post-register-modules/${homepage}`, token, modules);
}

export function DuplicateModulesForPostRegisterHomeView(
	homepage: number,
	token: string,
	modules: PageModule[]
): Promise<any> {
	return Post(`/v3/admin/events/homepage/modules/duplicate-for-home-view/${homepage}`, token, modules);
}
